import type {
  CogoCollabTransaction,
  CogoHistoryEvent,
  CogoHistoryState,
} from "./types";

export function createCogoHistoryState(): CogoHistoryState {
  return { done: [], undone: [] };
}

export function pushCogoHistoryEvent(input: {
  state: CogoHistoryState;
  transaction: CogoCollabTransaction;
  userEvent: string;
  eventId?: string;
  newGroupDelayMs?: number;
}): CogoHistoryState {
  const newGroupDelayMs = input.newGroupDelayMs ?? 500;
  const previous = input.state.done.at(-1);
  const createdAt = input.transaction.updatedAt ?? input.transaction.createdAt;
  const previousTime = previous ? Date.parse(previous.createdAt) : Number.NaN;
  const nextTime = Date.parse(createdAt);
  const canJoin =
    previous &&
    previous.userEvent === input.userEvent &&
    previous.actor.id === input.transaction.actor.id &&
    Number.isFinite(previousTime) &&
    Number.isFinite(nextTime) &&
    nextTime - previousTime <= newGroupDelayMs;

  const event: CogoHistoryEvent = {
    id: input.eventId ?? `${input.transaction.id}.history`,
    transactionIds: [input.transaction.id],
    actor: input.transaction.actor,
    userEvent: input.userEvent,
    createdAt,
  };

  if (!canJoin) {
    return {
      done: [...input.state.done, event],
      undone: [],
    };
  }

  const done = input.state.done.slice(0, -1);
  done.push({
    ...previous,
    transactionIds: [...previous.transactionIds, input.transaction.id],
    createdAt,
  });
  return { done, undone: [] };
}

export function undoCogoHistoryEvent(state: CogoHistoryState): {
  state: CogoHistoryState;
  event: CogoHistoryEvent | null;
} {
  const event = state.done.at(-1) ?? null;
  if (!event) return { state, event: null };
  return {
    event,
    state: {
      done: state.done.slice(0, -1),
      undone: [...state.undone, event],
    },
  };
}

export function redoCogoHistoryEvent(state: CogoHistoryState): {
  state: CogoHistoryState;
  event: CogoHistoryEvent | null;
} {
  const event = state.undone.at(-1) ?? null;
  if (!event) return { state, event: null };
  return {
    event,
    state: {
      done: [...state.done, event],
      undone: state.undone.slice(0, -1),
    },
  };
}
